interface ContactFormProps {
  page?: string;
  subject?: string;
  title?: string;
  subtitle?: string;
  placeholder?: string;
  showTitle?: boolean;
  submitLabel?: string;
  variant?: "wide" | "compact";
}

export default function ContactForm({
  page = "Site",
  subject = "Nouveau lead Dépan'Volets",
  title,
  subtitle,
  placeholder = "Décrivez votre problème de volet roulant...",
  showTitle = true,
  submitLabel = "Envoyer ma demande",
  variant = "wide",
}: ContactFormProps) {
  const isWide = variant === "wide";

  return (
    <div className={isWide ? "lg:col-span-7 min-w-0" : "min-w-0"}>
      {showTitle && title && (
        <div className="mb-4 md:mb-8">
          <h2 className="text-brand-blue text-xl md:text-2xl font-extrabold">
            {title}
          </h2>
          {subtitle && (
            <p className="text-brand-text leading-relaxed mt-2 text-sm md:text-base">
              {subtitle}
            </p>
          )}
        </div>
      )}

      <form
        action="https://formspree.io/f/xgoqgrbq"
        method="POST"
        className="bg-white rounded-xl md:rounded-2xl p-4 md:p-8 border border-brand-border/80 shadow-[0_8px_32px_rgba(20,58,102,0.1)] hover:shadow-[0_12px_40px_rgba(20,58,102,0.14)] transition-shadow duration-500 overflow-hidden"
      >
        <input type="text" name="_gotcha" style={{ display: "none" }} tabIndex={-1} autoComplete="off" />
        <input type="hidden" name="_subject" value={subject} />
        <input type="hidden" name="page" value={page} />
        <input type="hidden" name="_next" id="form-next" value="/merci" />
        <script
          dangerouslySetInnerHTML={{
            __html: `document.getElementById('form-next').value = window.location.origin + '/merci';`,
          }}
        />

        <div className="space-y-4 md:space-y-5">
          {/* Nom */}
          <div className="relative group">
            <label htmlFor="nom" className="block text-xs font-semibold text-brand-text/70 uppercase tracking-wider mb-1.5 md:mb-2">
              Nom
            </label>
            <div className="relative">
              <div className="absolute left-3 md:left-3.5 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-brand-text/30">
                <i className="ri-user-line text-base md:text-lg"></i>
              </div>
              <input
                id="nom"
                name="nom"
                type="text"
                required
                className="w-full bg-[#FAFBFC] rounded-lg md:rounded-xl pl-10 md:pl-11 pr-3 md:pr-4 py-3 md:py-3.5 text-sm text-brand-text placeholder-brand-text/30 border border-brand-border focus:border-brand-cyan focus:bg-white outline-none transition-all duration-300"
                placeholder="Votre nom"
              />
              <div className="absolute bottom-0 left-0 h-[2px] bg-brand-cyan rounded-full w-0 group-focus-within:w-full transition-all duration-300" />
            </div>
          </div>

          {/* Email + Téléphone côte à côte */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            <div className="relative group min-w-0">
              <label htmlFor="email" className="block text-xs font-semibold text-brand-text/70 uppercase tracking-wider mb-1.5 md:mb-2">
                E-mail
              </label>
              <div className="relative">
                <div className="absolute left-3 md:left-3.5 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-brand-text/30">
                  <i className="ri-mail-line text-base md:text-lg"></i>
                </div>
                <input
                  id="email"
                  name="email"
                  type="email"
                  required
                  className="w-full bg-[#FAFBFC] rounded-lg md:rounded-xl pl-10 md:pl-11 pr-3 md:pr-4 py-3 md:py-3.5 text-sm text-brand-text placeholder-brand-text/30 border border-brand-border focus:border-brand-cyan focus:bg-white outline-none transition-all duration-300"
                  placeholder="Votre e-mail"
                />
                <div className="absolute bottom-0 left-0 h-[2px] bg-brand-cyan rounded-full w-0 group-focus-within:w-full transition-all duration-300" />
              </div>
            </div>

            <div className="relative group min-w-0">
              <label htmlFor="telephone" className="block text-xs font-semibold text-brand-text/70 uppercase tracking-wider mb-1.5 md:mb-2">
                Téléphone
              </label>
              <div className="relative">
                <div className="absolute left-3 md:left-3.5 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-brand-text/30">
                  <i className="ri-phone-line text-base md:text-lg"></i>
                </div>
                <input
                  id="telephone"
                  name="telephone"
                  type="tel"
                  required
                  className="w-full bg-[#FAFBFC] rounded-lg md:rounded-xl pl-10 md:pl-11 pr-3 md:pr-4 py-3 md:py-3.5 text-sm text-brand-text placeholder-brand-text/30 border border-brand-border focus:border-brand-cyan focus:bg-white outline-none transition-all duration-300"
                  placeholder="Votre numéro"
                />
                <div className="absolute bottom-0 left-0 h-[2px] bg-brand-cyan rounded-full w-0 group-focus-within:w-full transition-all duration-300" />
              </div>
            </div>
          </div>

          {/* Code postal */}
          <div className="relative group">
            <label htmlFor="code_postal" className="block text-xs font-semibold text-brand-text/70 uppercase tracking-wider mb-1.5 md:mb-2">
              Code postal
            </label>
            <div className="relative">
              <div className="absolute left-3 md:left-3.5 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-brand-text/30">
                <i className="ri-map-pin-line text-base md:text-lg"></i>
              </div>
              <input
                id="code_postal"
                name="code_postal"
                type="text"
                required
                className="w-full bg-[#FAFBFC] rounded-lg md:rounded-xl pl-10 md:pl-11 pr-3 md:pr-4 py-3 md:py-3.5 text-sm text-brand-text placeholder-brand-text/30 border border-brand-border focus:border-brand-cyan focus:bg-white outline-none transition-all duration-300"
                placeholder="67000"
              />
              <div className="absolute bottom-0 left-0 h-[2px] bg-brand-cyan rounded-full w-0 group-focus-within:w-full transition-all duration-300" />
            </div>
          </div>

          {/* Message */}
          <div className="relative group">
            <label htmlFor="message" className="block text-xs font-semibold text-brand-text/70 uppercase tracking-wider mb-1.5 md:mb-2">
              Message
            </label>
            <div className="relative">
              <div className="absolute left-3 md:left-3.5 top-3 md:top-3.5 w-5 h-5 flex items-center justify-center text-brand-text/30">
                <i className="ri-message-3-line text-base md:text-lg"></i>
              </div>
              <textarea
                id="message"
                name="message"
                rows={3}
                maxLength={500}
                className="w-full bg-[#FAFBFC] rounded-lg md:rounded-xl pl-10 md:pl-11 pr-3 md:pr-4 py-3 md:py-3.5 text-sm text-brand-text placeholder-brand-text/30 border border-brand-border focus:border-brand-cyan focus:bg-white outline-none transition-all duration-300 resize-none"
                placeholder={placeholder}
              />
              <div className="absolute bottom-0 left-0 h-[2px] bg-brand-cyan rounded-full w-0 group-focus-within:w-full transition-all duration-300" />
            </div>
            <p className="text-[10px] text-brand-text/40 mt-1 text-right">500 caractères maximum</p>
          </div>
        </div>

        {/* RGPD */}
        <div className="mt-4 md:mt-5 flex items-start gap-2.5 md:gap-3">
          <input
            type="checkbox"
            name="consentement"
            required
            id="consentement"
            className="mt-0.5 md:mt-1 w-4 h-4 text-brand-cyan rounded border-brand-border focus:ring-brand-cyan cursor-pointer shrink-0"
          />
          <label htmlFor="consentement" className="text-xs text-brand-text/70 leading-relaxed cursor-pointer">
            J'accepte que mes données soient utilisées pour être recontacté(e).{" "}
            <a href="/politique-confidentialite" className="text-brand-cyan underline hover:no-underline">
              Politique de confidentialité
            </a>
          </label>
        </div>

        {/* Bouton */}
        <button
          type="submit"
          className="w-full mt-5 md:mt-7 bg-brand-cyan text-white px-5 md:px-6 py-3.5 md:py-4 rounded-full font-semibold text-sm md:text-base hover:scale-[1.02] active:scale-[0.98] hover:shadow-[0_4px_20px_rgba(0,179,164,0.35)] transition-all duration-300 w-full text-center overflow-hidden"
        >
          <span className="relative z-10 flex items-center justify-center gap-2">
            <i className="ri-send-plane-fill text-base md:text-lg"></i>
            {submitLabel}
          </span>
        </button>
      </form>
    </div>
  );
}